import { useTranslation } from "react-i18next";
import { Props, AvailabillityStatusesOptionValue, AvailabilityStatusesQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

import { AVAILABILITY_STATUSES } from "../../../utils/constants/constants";

export const AvailabilityStatusesQuickfilter = <Q extends AvailabilityStatusesQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.availability_statuses"; // tRP - translation root path

  const options: QuickFilterOption<AvailabillityStatusesOptionValue>[] = [
    {
      name: t(`${tRP}.all_candidates`),
      value: { availabilityStatusesId: null },
    },
    {
      name: AVAILABILITY_STATUSES.immediat.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.immediat.id },
    },
    {
      name: AVAILABILITY_STATUSES.oneWeek.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.oneWeek.id },
    },
    {
      name: AVAILABILITY_STATUSES.twoWeeks.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.twoWeeks.id },
    },
    {
      name: AVAILABILITY_STATUSES.oneMonth.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.oneMonth.id },
    },
    {
      name: AVAILABILITY_STATUSES.twoMonth.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.twoMonth.id },
    },
    {
      name: AVAILABILITY_STATUSES.onHold.name,
      value: { availabilityStatusesId: AVAILABILITY_STATUSES.onHold.id },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="availabilityStatuses"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
